import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Eye, AlertCircle, CheckCircle, Lightbulb } from 'lucide-react';
import '../../../assets/styles/customer/layout/OurStorySection.css';

const OurStorySection = () => {
  const storyCards = [
    {
      id: 1,
      icon: <Eye size={32} strokeWidth={2} />,
      title: 'The Vision',
      subtitle: 'Our Mission',
      description: 'To transform Pakistan\'s dairy supply chain through technology, making milk delivery transparent, efficient, and trustworthy for everyone.',
      color: '#3e96e7'
    },
    {
      id: 2,
      icon: <AlertCircle size={32} strokeWidth={2} />,
      title: 'The Problem',
      subtitle: 'What We Solve',
      description: 'Manual record-keeping leads to disputes, missed payments, and inefficient routes. We digitize everything for clarity and peace of mind.',
      color: '#ffc107'
    },
    {
      id: 3,
      icon: <CheckCircle size={32} strokeWidth={2} />,
      title: 'The Solution',
      subtitle: 'How We Help',
      description: 'QR-based tracking, automated billing, real-time updates, and digital payment records—all in one easy-to-use platform.',
      color: '#4caf50'
    }
  ];

  return (
    <section className="our-story-section">
      
      {/* Floating Bottles */}
      <div className="story-floating-bottles">
        <div className="story-bottle bottle-1">🥛</div>
        <div className="story-bottle bottle-2">🥛</div>
        <div className="story-bottle bottle-3">🥛</div>
      </div>

      {/* Wavy Background */}
      <div className="story-wave-bg">
        <svg className="story-wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.04)" 
            d="M0,96L48,112C96,128,192,160,288,154.7C384,149,480,107,576,101.3C672,96,768,128,864,138.7C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
      </div>

      {/* Decorative Circles */}
      <div className="story-circles">
        <div className="story-circle circle-1"></div>
        <div className="story-circle circle-2"></div>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="story-header text-center">
          <h2 className="story-title">
            Our <span className="story-highlight">Story</span>
          </h2>
          <p className="story-subtitle">
            From a simple idea to a platform serving thousands
          </p>
        </div>

        {/* Story Cards Grid */}
        <Row className="g-4 story-cards-row">
          {storyCards.map((card, index) => (
            <Col lg={4} md={4} sm={12} key={card.id}>
              <div 
                className="story-card"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                {/* Icon */}
                <div 
                  className="story-icon-wrapper"
                  style={{ backgroundColor: `${card.color}15` }}
                >
                  <div 
                    className="story-icon"
                    style={{ color: card.color }}
                  >
                    {card.icon}
                  </div>
                </div>

                {/* Content */}
                <h3 className="story-card-title">{card.title}</h3>
                <p className="story-card-subtitle" style={{ color: card.color }}>
                  {card.subtitle}
                </p>
                <p className="story-card-description">{card.description}</p>

                {/* Decorative Line */}
                <div 
                  className="story-card-line"
                  style={{ backgroundColor: card.color }}
                ></div>
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default OurStorySection;